import { LibraryBig, PanelsTopLeft } from "lucide-react";

import {
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  useSidebar,
} from "@/components/ui";
import { cn } from "@/lib/utils/cn";
import { Link } from "@tanstack/react-router";

const appsSubNavLabelClass =
  "[&>span:last-child]:min-w-0 [&>span:last-child]:whitespace-nowrap [&>span:last-child]:overflow-hidden [&>span:last-child]:text-ellipsis";

export const AppsSubMenu = ({ currentPath }: { currentPath: string }) => {
  const { setOpenMobile } = useSidebar();

  return (
    <SidebarMenuSub className="mt-1.5 mr-0 ml-2 gap-1 border-l-2 border-l-neutral-900 py-0.5 pr-0 pl-3">
      <SidebarMenuSubItem>
        <SidebarMenuSubButton asChild className={appsSubNavLabelClass}>
          <Link
            to="/apps/app-library"
            className={cn(
              currentPath === "/apps/app-library" &&
                "bg-neutral-900 text-white hover:bg-neutral-700 active:bg-neutral-700",
            )}
            onClick={() => {
              setOpenMobile(false);
            }}
          >
            <LibraryBig className="mr-2 h-4 w-4 shrink-0" />
            App library
          </Link>
        </SidebarMenuSubButton>
      </SidebarMenuSubItem>
      <SidebarMenuSubItem>
        <SidebarMenuSubButton asChild className={appsSubNavLabelClass}>
          <Link
            to="/apps/my-apps"
            className={cn(
              currentPath === "/apps/my-apps" &&
                "bg-neutral-900 text-white hover:bg-neutral-700 active:bg-neutral-700",
            )}
            onClick={() => {
              setOpenMobile(false);
            }}
          >
            <PanelsTopLeft className="mr-2 h-4 w-4 shrink-0" />
            Connected apps
          </Link>
        </SidebarMenuSubButton>
      </SidebarMenuSubItem>
    </SidebarMenuSub>
  );
};
